/* Modositva: Akos | branch: dev/akos | 2026-11-03 - Fuggetlen szekciofrissites, egyszeri ujralekeres es lathato tartalek kosarlink. */
const sectionsToRender = [
  {
    id: '#cart-counter',
    section: 'cart-counter',
    selector: '#shopify-section-cart-counter'
  },
  {
    id: '#CartDrawer-Body',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer-Body'
  }
];

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      event => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.querySelector('#CartDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.setCartLink();
    this.parentElement.addEventListener(
      'shopify:section:select',
      () => this.open()
    );
    this.parentElement.addEventListener(
      'shopify:section:deselect',
      () => this.close()
    );
  }

  setCartLink() {
    document.querySelectorAll('[data-cart-link]').forEach(link => {
      link.setAttribute('role', 'button');
      link.setAttribute('aria-haspopup', 'dialog');
    });
    const openFromLink = event => {
      const cartLink = event.target.closest('[data-cart-link]');
      if (!cartLink || !this.isConnected) return;
      if (event.type === 'keydown' && event.code !== 'Space') return;
      event.preventDefault();
      this.setActiveElement(cartLink);
      window.themeCart.enqueue(() => this.renderContents({}, true, false));
    };
    document.addEventListener('click', openFromLink);
    document.addEventListener('keydown', openFromLink);
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);
    this.classList.add('is-visible');
    this.addEventListener(
      'transitionend',
      () => {
        this.focusOnCartDrawer();
      },
      { once: true }
    );
    bodyScroll.lock(this.querySelector('[role="dialog"]'));

    if (document.querySelector('product-bar')) {
      document.querySelector('product-bar').style.opacity = '0';
    }
  }

  close() {
    this.classList.remove('is-visible');
    removeTrapFocus(this.activeElement);

    // const isHeaderMenuOpen = header.classList.contains('menu-open');

    // if (isHeaderMenuOpen) {
    //   return;
    // }

    bodyScroll.unlock(this.querySelector('[role="dialog"]'));

    // if we are on the cart page, resubmit form
    if (window.location.pathname === '/cart') {
      const cartDrawerForm = document.getElementById('CartDrawer-FormSummary');
      if (cartDrawerForm) {
        cartDrawerForm.submit();
      }
    }

    if (document.querySelector('product-bar')) {
      document.querySelector('product-bar').removeAttribute('style');
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  focusOnCartDrawer() {
    const containerToTrapFocusOn = this.firstElementChild;
    const focusElement = this.querySelector('[data-drawer-close]');
    trapFocus(containerToTrapFocusOn, focusElement);
  }

  async renderContents(response, open = true, added = true) {
    const updated = new Set();
    const applySections = sections => {
      this.getSectionsToRender().forEach(section => {
        const targets = document.querySelectorAll(section.id);
        const html = this.getSectionInnerHTML(sections?.[section.section], section.selector);
        if (!targets.length || html === null) return;
        targets.forEach(target => { target.innerHTML = html; });
        updated.add(section.section);
      });
    };

    applySections(response?.sections);
    if (updated.size !== this.getSectionsToRender().length) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const url = new URL(`${window.Shopify.routes.root}cart`, window.location.origin);
        url.searchParams.set('sections', this.getSectionsToRender().map(section => section.section).join(','));
        const result = await fetch(url, { cache: 'no-store', signal: controller.signal });
        if (!result.ok) throw new Error(`Cart sections: ${result.status}`);
        applySections(await result.json());
      } catch (error) {
        console.error('Cart display refresh failed', error);
      } finally {
        clearTimeout(timeout);
      }
    }

    const complete = updated.size === this.getSectionsToRender().length;
    const status = this.querySelector('[data-cart-refresh-status]');
    if (status) {
      status.hidden = complete;
      status.querySelector('[data-cart-refresh-message]').textContent =
        added ? this.dataset.addedMessage : this.dataset.refreshMessage;
    }
    const body = this.querySelector('#CartDrawer-Body');
    if (body) body.hidden = !updated.has('cart-drawer');
    if (open) this.open();
    return complete;
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    if (typeof html !== 'string') return null;
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML ?? null;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
